module.exports = __webpack_public_path__ + "static/media/gallery-11.7baadf46.jpg";